export const ACTION_PREFIX_UNIVERSAL = 'universal'